(() => {
  const subtitleSelector = '.product-subtitle, .tp-lead, .subtitle, .subtitle--small, .subtitle--medium, .subtitle--large, .card__subtitle, .collection-subtitle, [data-subtitle]';
  function punctuate(root) {
    root.querySelectorAll(subtitleSelector).forEach(subtitle => {
      const text = subtitle.textContent.trim();
      if (!text || text.endsWith('.')) return;
      const walker = document.createTreeWalker(subtitle, NodeFilter.SHOW_TEXT);
      let last;
      while (walker.nextNode()) {
        if (walker.currentNode.nodeValue.trim()) last = walker.currentNode;
      }
      if (last) last.nodeValue = last.nodeValue.trimEnd() + '.';
    });
  }
  punctuate(document);
  document.addEventListener('shopify:section:load', event => punctuate(event.target));
  document.addEventListener('input', event => {
    const note = event.target;
    if (!note.matches('.tp-gift textarea[data-note]')) return;
    const toggle = note.closest('.tp-gift').querySelector('[data-gift-toggle]');
    const selected = Boolean(note.value.trim());
    if (toggle && toggle.checked !== selected) {
      toggle.checked = selected;
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();